import { z } from "zod";

const scale = z.number().min(0.01).max(1);
/** Limits are fractions of the original typography, never cumulative reductions. */
export const copyfitSchema = z
  .object({
    minFontScale: scale,
    minLeadingScale: scale,
    minSpaceBeforeScale: z.number().min(0).max(1),
    minSpaceAfterScale: z.number().min(0).max(1),
    maxLinesPerParagraph: z.number().int().min(1).max(10000).optional(),
    uniformGroup: z.string().trim().min(1).max(100).optional(),
  })
  .strict();
export type Copyfit = z.infer<typeof copyfitSchema>;

/** A uniform group obeys the strictest limit of every visible participating frame. */
export function mergeCopyfitLimits(a: Copyfit, b: Copyfit): Copyfit {
  return {
    ...a,
    minFontScale: Math.max(a.minFontScale, b.minFontScale),
    minLeadingScale: Math.max(a.minLeadingScale, b.minLeadingScale),
    minSpaceBeforeScale: Math.max(a.minSpaceBeforeScale, b.minSpaceBeforeScale),
    minSpaceAfterScale: Math.max(a.minSpaceAfterScale, b.minSpaceAfterScale),
  };
}
